<template>
  <div class="about-wrapper">
    <div class="about">
      <div class="about-image">
        <img src="@/assets/nate2.jpg" />
      </div>
      <div class="about-content">
        <p>Nathaniel “Nate” W. E. Intolubbe is a fiction author based in Phoenix, Arizona. He has recently published his first book, The Cases of Inspector Marshall, Vol. I, which is available on Amazon for ebook and paperback.</p>
        <p>He is also an Eagle Scout, International Baccalaureate Diploma holder, and graduate from the University of California at Irvine.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
  components: {},
  mounted() {
    this.$parent.$analytics.setCurrentScreen("about");
    this.$parent.$analytics.logEvent("page_view");
  }
};
</script>

<style lang="scss">
.about-wrapper {
  background-image: url("~@/assets/blog-bg-3.jpg");
  /* Full height */
  //  height: 100%;
  padding-top: 200px;
  padding-bottom: 200px;

  /* Create the parallax scrolling effect */
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.about {
  margin-top: 20px;
  padding-top: 100px;
  padding-bottom: 100px;
  background-color: #34515e; //#cecece;
  color: white;
}
.about-image {
  img {
    width: 400px;
  }
}
.about-content {
  width: 40%;
  margin: 12px auto;
  text-align: left;
  p {
    margin-top: 20px;
    font-size: 16pt;
  }
}
@media only screen and (max-width: 768px) {
  .about-image {
    img {
      margin: 12px auto;
      width: 300px;
    }
  }
  .about-content {
    width: 80%;
  }
  .about-wrapper {
    padding: 0px;
    background-image: none;
  }
}
</style>